import { render, staticRenderFns } from "./product-changes.vue?vue&type=template&id=eb617d96&scoped=true"
import script from "./product-changes.vue?vue&type=script&lang=js"
export * from "./product-changes.vue?vue&type=script&lang=js"
import style0 from "./product-changes.vue?vue&type=style&index=0&id=eb617d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb617d96",
  null
  
)

export default component.exports